export default __webpack_public_path__ + "static/big-white-canada-e0b90a7f03040b17d0b8731fdd48b6e9.jpg";